import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-cycle
import {
  login, logout, getInfo, modifyPassword,
} from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth';

// groups配置routers转正则数组
const genGroupRouters = (groups) => {
  const allRouters = [];
  groups.forEach((group) => {
    if (group.routers) {
      allRouters.push(
        ...group.routers
          .split(/[\n\r]+/g)
          .filter(x => !!x)
          .map(g => new RegExp(`^${g.replace('*', '\\S*')}$`)),
      );
    }
  });
  return allRouters;
};

const getQueryString = () => {
  const result = window.location.href.match(new RegExp('[?&][^?&]+=[^?&]+', 'g'));
  if (!result) {
    return {};
  }
  return result.reduce((t, c) => {
    if (c) {
      const s = c.substring(1).split('=');
      if (s[0]) {
        t[s[0]] = s.length > 1 ? s[1] : '';
      }
    }
    return t;
  }, {});
};

const user = {
  state: {
    token: getToken(),
    name: '',
    groups: [],
    groupType: 'customer',
    userGroup: { id: null, name: '' },
    id: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_GROUPS: (state, groups) => {
      state.groups = groups;
    },
    SET_USER_GROUP: (state, userGroup) => {
      state.userGroup = userGroup;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_GROUPS_TYPE: (state, groupType) => {
      state.groupType = groupType;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.verify_code, userInfo.uuid)
          .then((response) => {
            const { data } = response;
            setToken(data.token);
            commit('SET_TOKEN', data.token);
            commit('SET_GROUPS', genGroupRouters(data.auth_groups || []));
            commit('SET_GROUPS_TYPE', (data.user_groups && data.user_groups.group_type) || 'customer');
            commit('SET_USER_GROUP', data.user_groups || {});
            commit('SET_NAME', data.realname || data.name);
            if (data.id) {
              commit('SET_ID', data.id);
              Cookies.set('user_id', data.id);
            }
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then((response) => {
            const { data } = response;
            // if (data.groups) { // 验证返回的roles是否是一个非空数组
            commit('SET_GROUPS', genGroupRouters(data.auth_groups || []));
            commit('SET_GROUPS_TYPE', (data.user_groups && data.user_groups.group_type) || 'customer');
            // } else {
            //   reject('getInfo: groups must be a non-null array !')
            // }
            commit('SET_NAME', data.realname || data.name);
            commit('SET_USER_GROUP', data.user_groups || {});
            if (data.id) {
              commit('SET_ID', data.id);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '');
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve();
      });
    },
  },
};

export default user;
